(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gc-poison-menu-halloween"] && !Shopify.designMode) return;
  try {
    
  const initialiseGcPotionAtmosphere = (root) => {
    const sections = [...root.querySelectorAll('[data-potion-atmosphere]')];
    if (sections.length === 0 || root.dataset.atmosphereReady === 'true') return;

    root.dataset.atmosphereReady = 'true';
    const defaultPrimary = getComputedStyle(root).getPropertyValue('--gc-red').trim() || '#a71920';
    const visibility = new Map(sections.map((section) => [section, 0]));
    const applyAtmosphere = (section) => {
      sections.forEach((item) => item.classList.toggle('is-atmosphere-active', item === section));
      if (!section) {
        root.style.setProperty('--gc-active-primary', defaultPrimary);
        root.style.setProperty('--gc-active-secondary', defaultPrimary);
        return;
      }
      root.style.setProperty('--gc-active-primary', section.dataset.potionPrimary || defaultPrimary);
      root.style.setProperty('--gc-active-secondary', section.dataset.potionSecondary || section.dataset.potionPrimary || defaultPrimary);
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => visibility.set(entry.target, entry.isIntersecting ? entry.intersectionRatio : 0));
      let activeSection = null;
      let highestVisibility = 0;
      visibility.forEach((ratio, section) => {
        if (ratio > highestVisibility) {
          highestVisibility = ratio;
          activeSection = section;
        }
      });
      applyAtmosphere(activeSection);
    }, {
      rootMargin: '-18% 0px -36% 0px',
      threshold: [0, .08, .18, .32, .5, .7]
    });

    sections.forEach((section) => observer.observe(section));
  };


  document.querySelectorAll('.gc-poison').forEach(initialiseGcPotionAtmosphere);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.gc-poison').forEach(initialiseGcPotionAtmosphere);
  });

  } catch(e) { console.error(e); }
})();
})();
